"use client";

import { useActiveGame } from "@/app/oyun/_hooks/useActiveGame";
import { defaultLocale, isLocale } from "@/i18n/config";
import { localizeHref } from "@/i18n/navigation";
import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";
import { useState } from "react";

export function useNavbarPlay(isAuthenticated: boolean) {
    const router = useRouter();
    const rawLocale = useLocale();
    const locale = isLocale(rawLocale) ? rawLocale : defaultLocale;
    const activeGameRoomCode = useActiveGame();
    const [isCreateGameDialogOpen, setIsCreateGameDialogOpen] = useState(false);

    const startPlaying = () => {
        if (activeGameRoomCode) {
            router.push(localizeHref(`/oyun/${activeGameRoomCode}`, locale));
            return;
        }

        if (!isAuthenticated) {
            router.push(localizeHref("/login", locale));
            return;
        }

        setIsCreateGameDialogOpen(true);
    };

    return {
        isCreateGameDialogOpen,
        setIsCreateGameDialogOpen,
        startPlaying,
    };
}
